import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap';

const ReasonModal = (props) => {
const {
resonFormik,
setShowResonModal,
showResonModal,
} = props
  return (
      <Modal show={showResonModal?.modalStatus} onHide={() => { setShowResonModal(false); resonFormik.resetForm() }} centered className='manual-tat'>
          <Modal.Header closeButton>
              <Modal.Title> Please Provide The Reason</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Form onSubmit={resonFormik.handleSubmit}>
                  <div className=''>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Reason</Form.Label>
                          <Form.Control
                              name='reason'
                              type="text"
                              autoComplete="false"
                              // isValid={resonFormik.touched?.reason && !resonFormik.errors?.reason}
                              isInvalid={!!resonFormik.errors?.reason}
                              value={resonFormik.values?.reason}
                              className='b-r-10 form-control-solid'
                              onChange={resonFormik.handleChange}
                              onBlur={resonFormik.handleBlur}
                              // 
                              placeholder="Reason"
                          />
                          <Form.Control.Feedback type="invalid">{resonFormik.errors?.reason}</Form.Control.Feedback>
                      </Form.Group>

                  </div>
                  <div className='d-flex flex-row justify-content-center'>
                      <Button disabled={resonFormik.isSubmitting} type="submit" className='btn btn-light btn-active-primary' variant="primary" >Submit</Button>
                  </div>
              </Form>
          </Modal.Body>
      </Modal>
  )
}

export default ReasonModal
